export const DEFAULT_YEAR = '2026/27';